export const LABELS = {
  issueCreateDialogTitleTemplatePane: (relationType: 'issue' | 'sub-issue' = 'issue') => `Create new ${relationType}`,
  issueCreateChooseDiffTemplate: 'Choose a different template',
  issueCreateDialogTitleCreationPane: (
    repoNwo: string,
    templateName: string | undefined,
    relationType: 'issue' | 'sub-issue' = 'issue',
  ) => `Create new ${relationType} in ${repoNwo}${templateName ? `: ${templateName}` : ''}`,
  issueCreateDialogTitleDuplicationPane: (repoNwo: string, relationType: 'issue' | 'sub-issue' = 'issue') =>
    `Clone current ${relationType} in ${repoNwo}`,
  issueCreateTitleLabel: 'Add a title',
  issueCreateTitlePlaceholder: 'Title',
  issueCreateBodyLabel: 'Add a description',
  issueCreatedPrefix: 'Issue created ',
  lastIssueCreated: (issueNumber: number) => `Issue #${issueNumber} created`,
  issuesDisabledForRepo: 'Issues are disabled for the selected repository. Please select a different repository.',
  issueBodyPlaceholder: 'Type your description here…',
  issueNumber: (issueNumber: number) => `#${issueNumber}`,
  blankIssueName: 'Blank issue',
  blankIssueDescription: 'Create a new issue from scratch',
  blankIssueMaintainerLabel: 'Maintainers only',
  securityPolicyName: 'Report a security vulnerability',
  securityPolicyDescription: 'Please review our security policy for more details',
  editTemplates: 'Edit templates',
  viewTemplates: 'View templates',
  templatesFormsTitle: 'Templates and forms',
  noTemplates: 'No templates available for the current repository',
  discardConfirmation: {
    title: 'Discard changes?',
    content: 'You have unsaved changes. Are you sure you want to discard them?',
    confirm: 'Close and discard',
    cancel: 'Keep editing',
  },
  loadingTooltip: 'Loading...',
  templateId: (template: string) => `template-item-${template}`,
  templateLabelId: (template: string) => `template-item-${template}-label`,
  templateDescriptionId: (template: string) => `template-item-${template}-description`,
  typePickerLabel: 'Type',
  selectIssueTypeLabel: 'create-issue-issue-type-label',
  fileUploadWarning: 'Issue will be created once your upload has completed',
  issueTypeReadOnly: 'You do not have permission to change the type',
  issueTypeReadOnlyReason: 'You need the triage role or higher in this repository to change the issue type.',
  viewProfile: (login: string) => `View ${login}'s profile`,
  copilotCTAButton: 'Write with Copilot',
  copilotCTADialogTitle: 'Navigate to Copilot Chat',
  copilotCTADialogDescription: 'You have unsaved changes. Are you sure you want to discard them?',
  copilotCTADialogCancelButton: 'Keep editing',
  copilotCTADialogContinueButton: 'Go to Copilot',
  copilotGenerateDialogTitle: 'Generate issue content with Copilot',
  copilotGenerateDialogTextareaLabel: 'Additional context (optional)',
  copilotGenerateDialogTextareaPlaceholder: 'Add any additional context to help Copilot generate a better issue...',
  copilotGenerateDialogGenerateButton: 'Generate content',
  copilotGenerateError: 'Failed to generate content with Copilot. Please try again.',
  copilotGenerateValidationWarning:
    'Please provide a title, existing description, or additional context to generate content.',
  copilotPanelInitialMessage: 'How can I help you write your issue?',
  copilotPanelInputPlaceholder: 'Type your message here...',
  copilotPanelSendButton: 'Send',
  copilotPanelUpdatedMessage: "I've updated the issue title and description above.",
  copilotPanelLoadingMessage: 'Writing…',
  copilotPanelAcceptButton: 'Accept',
  copilotPanelDiscardButton: 'Discard',
  copilotPanelTryAgainButton: 'Try again',
  copilotDiscardConfirmDialog: {
    title: 'Discard changes?',
    content: 'You have made edits to the generated content. Discarding will lose your changes.',
    confirm: 'Discard',
    cancel: 'Cancel',
  },
  copilotTryAgainConfirmDialog: {
    title: 'Try again?',
    content:
      'You have made edits to the generated content. Trying again will replace your changes with new generated content.',
    confirm: 'Try again',
    cancel: 'Cancel',
  },
  backToAllIssues: 'Back to all issues',
  crossRepoIssueDuplicationWarning: (droppedMetadata: string[]) =>
    `This issue is being cloned across repositories. The following metadata might not be copied: ${droppedMetadata.join(
      ', ',
    )}.`,
  crossRepoIssueDuplicationDefaultWarning:
    'Changing the repository may remove Milestone, Labels, Type, and Assignees from the cloned issue.',
  setAdditionalFields: 'Set additional issue fields',
  potentialDuplicate: 'Potential duplicate',
  duplicatesCount: (count: number) => `${count} potential duplicates`,
  dismissDuplicates: (count: number) => `Dismiss potential duplicate${count === 1 ? '' : 's'}`,
  dismissDuplicatesTooltip: 'Dismiss',
  visibilityIndicatorTooltip: 'Field is visible to the public.',
  issueCreationRestricted:
    'An owner of this repository has limited the ability to create an issue to users that are collaborators.',
}
